import Icon from '@mercadoni/sinister/dist/cjs/Icon'
import { Button } from 'antd'
import { FC } from 'react'

interface AtomicDrawerHeaderProps {
  className?: string
  copy: string
  onClose: () => void
}

const DrawerHeader: FC<AtomicDrawerHeaderProps> = ({
  className,
  copy,
  onClose,
}) => (
  <div className={className}>
    <span className="pages-header">{copy}</span>
    <Button
      onClick={onClose}
      type="link"
      icon={<Icon className="ph-x" color="var(--color-black)" />}
    />
  </div>
)

export default DrawerHeader
